module.exports = __webpack_public_path__ + "img/trezor.5bb513d8.jpg";